import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface ITowOnTypeCargoCharacteristicAttributes extends IModelAttributes {
	towOnTypeId: string;
	cargoCharacteristicId: string;

	towOnType: Models.TowOnTypeEntity | Models.ITowOnTypeEntityAttributes;
	cargoCharacteristic: Models.CargoCharacteristicEntity | Models.ICargoCharacteristicEntityAttributes;
}

@entity('TowOnTypeCargoCharacteristic')
export default class TowOnTypeCargoCharacteristic extends Model implements ITowOnTypeCargoCharacteristicAttributes {
	@observable
	@attribute()
	public cargoCharacteristicId: string;

	@observable
	@attribute()
	public towOnTypeId: string;

	@observable
	@attribute({ isReference: true })
	public towOnType: Models.TowOnTypeEntity;

	@observable
	@attribute({ isReference: true })
	public cargoCharacteristic: Models.CargoCharacteristicEntity;

	constructor(attributes?: Partial<ITowOnTypeCargoCharacteristicAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.towOnTypeId) {
				this.towOnTypeId = attributes.towOnTypeId;
			}
			if (attributes.cargoCharacteristicId) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}

			if (attributes.towOnType) {
				if (attributes.towOnType instanceof Models.TowOnTypeEntity) {
					this.towOnType = attributes.towOnType;
					this.towOnTypeId = attributes.towOnType.id;
				} else {
					this.towOnType = new Models.TowOnTypeEntity(attributes.towOnType);
					this.towOnTypeId = this.towOnType.id;
				}
			} else if (attributes.towOnTypeId !== undefined) {
				this.towOnTypeId = attributes.towOnTypeId;
			}

			if (attributes.cargoCharacteristic) {
				if (attributes.cargoCharacteristic instanceof Models.CargoCharacteristicEntity) {
					this.cargoCharacteristic = attributes.cargoCharacteristic;
					this.cargoCharacteristicId = attributes.cargoCharacteristic.id;
				} else {
					this.cargoCharacteristic = new Models.CargoCharacteristicEntity(attributes.cargoCharacteristic);
					this.cargoCharacteristicId = this.cargoCharacteristic.id;
				}
			} else if (attributes.cargoCharacteristicId !== undefined) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}
		}
	}
}
